import BaseOnboardingService from "./baseOnboarding.service";

class UnavailabilityInjuryNatureService extends BaseOnboardingService {
  constructor() {
    super("unavailability-injuryNature");
  }
}

export default new UnavailabilityInjuryNatureService();